import DynamicSectionElement from '@/scripts/dynamic-section-element.js'
import { trapFocus, removeTrapFocus } from '@shopify/theme-a11y'
import { handleLinksClick } from '@/scripts/datalayer'
import { handleArrowDown, handleArrowUp } from '@/scripts/accessibility'
import { decode } from '@/scripts/utils'

class MenuSlideout extends DynamicSectionElement {
  constructor () {
    super()

    this.inputField = this.querySelector('input[name="q"]')

    this.addEventListener('keyup', (event) => {
      const eventCode = event.code.toUpperCase()
      const body = document.body
      if (eventCode === 'ESCAPE') {
        if (body.classList.contains('is-open-menu-level-3')) {
          this.focusActiveMenuLevel2()
          const arialabel2Els = document.querySelectorAll('.js-content-menu-level-2 button.js-open-menu-level-3')
          this.resetAriaExpanded(arialabel2Els)
          this.hiddenMenuLevel('is-open-menu-level-3')
        }
        else if (body.classList.contains('is-open-menu-level-2')) {
          this.focusActiveMenuLevel1()
          const arialabel1Els = document.querySelectorAll('.js-menu-level-1 button.js-open-menu-level-3')
          this.resetAriaExpanded(arialabel1Els)
          this.hiddenMenuLevel('is-open-menu-level-2')
        } else {
          this.closeDrawer()
          if (document.body.classList.contains('user-is-tabbing')) {
            trapFocus(document.body, {
              elementToFocus: document.querySelector('.js-button-slideout')
            })
          }
        }
      }
      const el = event.target
      if (eventCode === 'ENTER' || eventCode === 'SPACE') {
        if (el.classList.contains('js-open-menu-level-2')) {
          this.setAriaExpandedButton(el, true)
          document.querySelector('menu-slideout').openChildMenu(el)
          this.focusMenuLevel2()
        }
      }

      if (el.closest('.js-menu-level-1')) {
        if (eventCode === 'ARROWDOWN') {
          handleArrowDown(el, this)
        }

        if (eventCode === 'ARROWUP') {
          handleArrowUp(el, this)
        }
      }

      if (el.closest('.js-menu-level-2')) {
        const menuLevel2El = el.closest('.js-menu-level-2')
        if (eventCode === 'ARROWDOWN') {
          handleArrowDown(el, menuLevel2El)
        }

        if (eventCode === 'ARROWUP') {
          handleArrowUp(el, menuLevel2El)
        }
      }

      if (el.closest('.js-menu-level-3')) {
        const menuLevel3El = el.closest('.js-menu-level-3')
        if (eventCode === 'ARROWDOWN') {
          handleArrowDown(el, menuLevel3El)
        }

        if (eventCode === 'ARROWUP') {
          handleArrowUp(el, menuLevel3El)
        }
      }
    })
  }

  openDrawer (event) {
    if (event && event.preventDefault) {
      if (event.metaKey) {
        return
      }
      event.preventDefault()
    }
    const buttonEl = event.target.closest('button')
    if (buttonEl && buttonEl.classList.contains('js-button-slideout') || buttonEl.classList.contains('js-search-icon') || buttonEl.classList.contains('js-menu-bars')) {
      buttonEl.setAttribute('aria-expanded', 'true')
    }

    this.classList.add('open-slideout')
    document.body.classList.add('overflow-hidden')
    document.body.classList.add('is-open-slideout')
    if (event && event.currentTarget) {
      const activeHandle = this.querySelector(`[data-handle="${event.currentTarget.dataset.handle}"]`)
      this.openChildMenu(activeHandle)
    }

    const isSearchClick = event.currentTarget.classList.contains('js-search-icon')
    if (document.body.classList.contains('user-is-tabbing') || isSearchClick) {
      trapFocus(this, {
        elementToFocus: this.inputField
      })
    }
  }

  closeDrawer () {
    this.classList.remove('open-slideout')
    document.body.classList.remove('overflow-hidden', 'is-open-slideout', 'is-open-menu-level-2', 'is-open-menu-level-3' )
    this.inputField.value = ''
    document.querySelector('.js-data-predictive-search').classList.add('hidden')
    document.querySelector('.js-button-slideout').setAttribute('aria-expanded', 'false')
    document.querySelector('.js-search-icon').setAttribute('aria-expanded', 'false')
    document.querySelector('.js-menu-bars').setAttribute('aria-expanded', 'false')

    removeTrapFocus()
  }

  openChildMenu (element) {
    this.hiddenMenuLevel('is-open-menu-level-3')
    this.hiddenMenuLevel2()
    if (element && element.dataset.links) {
      const data = JSON.parse(decode(element.dataset.links))
      const withoutDecodeData = JSON.parse(element.dataset.links)

      const current = data[0].current
      document.querySelector('.js-selected-menu-level-2').textContent = current
      const contentEl = document.querySelector('.js-content-menu-level-2')
      let htmlItem = []

      data.forEach(item => {
        const dTitle = withoutDecodeData.find((i)=> {
            return decode(i.title).includes(item.title)
        })
        const title = dTitle ? dTitle.title : item.title
        const openNewTab = item.openNewTab ? 'target="_blank"' : ''
        const dataMenu = item.links.data.length > 0 ? `data-links='${JSON.stringify(item)}'` : ''
        const dataLabel = `aria-label="${item.title}"`
        const jsClass = item.links.data.length > 0 ? 'js-open-menu-level-3' : ''
        const icon = item.links.data.length > 0 ? `<button class="icon w-[20px] h-[20px] text-black cursor-pointer ${jsClass}" ${dataLabel} aria-expanded="false" ${dataMenu}>
            <svg viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 5.49987L5.58197 5.96454L1.12259 11L1.20094e-07 10.0709L4.04897 5.5L1.10796e-08 0.92912L1.12259 -1.33867e-08L5.58197 5.03546L6 5.50013L6 5.49987Z" fill="currentColor"/>
            </svg>
          </button>` : ''
          let menuItem = `<li class="relative cursor-pointer menu-slideout-item flex justify-between items-center mt-[22px] js-menu-item js-menu-item-level-2">
              <a href="${item.link}" ${openNewTab} class="menu-text header-link flex w-fit justify-between js-open-menu-level-3 menu-slideout-subitem ${jsClass}" ${dataMenu} data-component="Left Hand Nav" data-position="Secondary">
                <span>${title}</span>
              </a>
              ${icon}
          </li>`
        htmlItem.push(menuItem)
      })

      const dataMenuHTML = `
        <div class="flex flex-col w-full">${htmlItem.join('')}</div>
        `
      contentEl.innerHTML = dataMenuHTML

      this.resetAllActiveMenuLevel('.js-menu-item')
      const parentEl = element.parentElement
      parentEl.classList.add('active')
      this.openMenuLevel('is-open-menu-level-2')
      this.openChildMenuLevel3()
    }
  }

  openChildMenuLevel3 () {
    const menuItemLevel3Els = document.querySelectorAll('.js-open-menu-level-3')

    handleLinksClick(menuItemLevel3Els)

    menuItemLevel3Els.forEach(item => {
      const handleMenuLevel3 = (item) => {
        if (!item.dataset.links) {
          this.hiddenMenuLevel('is-open-menu-level-3')
          return
        }
        const data = JSON.parse(item.dataset.links)
        const current = data.links.current
        document.querySelector('.js-selected-menu-level-3').textContent = current
        const contentEl = document.querySelector('.js-content-menu-level-3')

        let htmlItem = []

        data.links.data.forEach(item => {
          const openNewTab = item.openNewTab ? 'target="_blank"' : ''
          let icon = item.type === 'collection_link' && item.icon ? `<img width="20px" height="20px" src="${item.icon}" alt="${item.title}">` : ''
          let menuItem = `<li class="flex justify-between items-center mt-[22px]">
            <a href="${item.link}" ${openNewTab} class="menu-text header-link w-fit js-datalayer-menu-item-level-3 js-menu-item-level-3 menu-slideout-subitem" data-component="Left Hand Nav" data-position="Tertiary"><span>${item.title}</span></a>
            ${icon}
            </li>`
          htmlItem.push(menuItem)
        })

        const dataMenuHTML = `<div class="flex flex-col w-full">${htmlItem.join('')}</div>`
        contentEl.innerHTML = dataMenuHTML

        this.resetAllActiveMenuLevel('.js-menu-item-level-2')
        const parentEl = item.parentElement
        parentEl.classList.add('active')
        this.openMenuLevel('is-open-menu-level-3')

        const menuItemLevel3 = document.querySelectorAll('.js-datalayer-menu-item-level-3')
        handleLinksClick(menuItemLevel3)
      }

      item.addEventListener('mouseover', () => {
        handleMenuLevel3(item)
      })

      item.addEventListener('keyup', (event) => {
        const eventCode = event.code.toUpperCase()
        if (eventCode === 'ENTER' || eventCode === 'SPACE') {
          handleMenuLevel3(item)
          this.setAriaExpandedButton(item, true)
          const childMenuLevel3Els = document.querySelectorAll('.js-menu-item-level-3')
          const containerMenuLevel3El = document.querySelector('.js-content-menu-level-3')
          this.openMenuLevel('is-open-menu-level-3')
          trapFocus(containerMenuLevel3El, {
            elementToFocus: childMenuLevel3Els[0]
          })
        }
      })
    })
  }

  resetAllActiveMenuLevel (className) {
    const menuItemEls = document.querySelectorAll(className)
    menuItemEls.forEach(item => {
      if (item.classList.contains('active')) {
        item.classList.remove('active')
      }
    })
  }

  focusMenuLevel2 () {
    const childEls = document.querySelectorAll('.js-menu-item-level-2')
    const containerEl = document.querySelector('.js-content-menu-level-2')
    trapFocus(containerEl, {
      elementToFocus: childEls[0].querySelector('a')
    })
  }

  focusActiveMenuLevel2 () {
    const childActiveEl = document.querySelector('.js-menu-item-level-2.active')
    const containerEl = document.querySelector('.js-content-menu-level-2')
    trapFocus(containerEl, {
      elementToFocus: childActiveEl.querySelector('a')
    })
  }

  focusActiveMenuLevel1 () {
    const childActiveEl = document.querySelector('.js-menu-item-level-1.active')
    const containerEl = document.querySelector('.js-menu-level-1')
    trapFocus(containerEl, {
      elementToFocus: childActiveEl.querySelector('a')
    })
  }

  openMenuLevel(className) {
    const body = document.body
    if (!body.classList.contains(className)) {
      body.classList.add(className)
    }
  }

  hiddenMenuLevel2() {
    this.resetAllActiveMenuLevel('.js-menu-item')
    this.hiddenMenuLevel('is-open-menu-level-3')
    this.hiddenMenuLevel('is-open-menu-level-2')
  }

  resetAriaExpanded(el) {
    el.forEach(item => {
      this.setAriaExpandedButton(item, false)
    })
  }

  setAriaExpandedButton (el, value) {
    if (el.hasAttribute('aria-expanded')) {
      el.setAttribute('aria-expanded', value)
    }
  }

  hiddenMenuLevel(className) {
    const body = document.body
    if (body.classList.contains(className)) {
      body.classList.remove(className)
    }
  }
}

customElements.define('menu-slideout', MenuSlideout)
